import platform from "../../util/platform";
const registerNewUser = (request) => {
    const path = `/register/user`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const registerNewApp = (request) => {
    const path = `/register/app`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const checkHostnameAvailable = (hostname) => {
    const path = `/register/app/hostname/${hostname}/validate`;
    return (params) => {
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const session = {
    registerNewUser,
    registerNewApp,
    checkHostnameAvailable,
};
export default session;
